export const BLOCK_NAME = 'b-stage-alert'

export const ALERT_CONTENT = 'Stage'
